// ─────────────────────────────────────────────────────────────────────────────
// main-cart-items.js — Solo funcionalidad CUSTOM
//
// cart.js maneja: quantity +/-, remove, section re-render, pub/sub.
// Aquí viven: cajas custom, barra de envío gratis, totales.
// ─────────────────────────────────────────────────────────────────────────────

class CartManager {
  constructor() {
    this.setupBoxToggle();
    this.setupBoxRemove();
    this.updateQuantityButtonStates();
    this.listenToCartUpdates();
    this.initFreeShippingBar();
  }

  // ─── CAJAS PERSONALIZADAS ─────────────────────────────────────────────────

  setupBoxToggle() {
    document.addEventListener('click', (e) => {
      const header = e.target.closest('.custom-box-header');
      if (!header) return;
      if (e.target.closest('.custom-box-remove')) return;
      const container = header.closest('.custom-box-container');
      if (container) this.toggleBox(container);
    });
  }

  toggleBox(container) {
    const isExpanded = container.classList.contains('custom-box-expanded');
    container.classList.toggle('custom-box-expanded', !isExpanded);
    const content = container.querySelector('.custom-box-content');
    if (!content) return;
    if (!isExpanded) {
      content.style.maxHeight = content.scrollHeight + 'px';
      content.style.opacity = '1';
    } else {
      content.style.maxHeight = '0';
      content.style.opacity = '0';
    }
  }

  setupBoxRemove() {
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-remove-box]');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      this.removeBox(btn.getAttribute('data-remove-box'));
    });
  }

  async removeBox(boxId) {
    if (!confirm('¿Estás seguro de que quieres eliminar esta caja completa?')) return;

    const container = document.getElementById(`CustomBox-${boxId}`);
    if (!container) return;
    container.classList.add('loading');

    const updates = {};
    container.querySelectorAll('[data-item-key]').forEach(el => {
      const key = el.getAttribute('data-item-key');
      if (key) updates[key] = 0;
    });

    if (!Object.keys(updates).length) {
      alert('No se encontraron items válidos para eliminar');
      container.classList.remove('loading');
      return;
    }

    try {
      const res = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates })
      });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);

      container.style.transition = 'opacity 0.3s ease, transform 0.3s ease';
      container.style.opacity = '0';
      container.style.transform = 'translateX(-20px)';
      setTimeout(() => container.remove(), 300);
      this.reloadCartSection();

    } catch (err) {
      console.error('Error eliminando caja:', err);
      alert('Error al eliminar la caja. Inténtalo de nuevo.');
      container.classList.remove('loading');
    }
  }

  reloadCartSection() {
    const cartItemsEl = document.getElementById('main-cart-items');
    if (!cartItemsEl) { window.location.reload(); return; }

    fetch(`${window.location.pathname}?section_id=${cartItemsEl.dataset.id}`)
      .then(res => res.text())
      .then(html => {
        const parsed = new DOMParser().parseFromString(html, 'text/html');
        const newContent = parsed.querySelector('.js-contents');
        const currentContent = cartItemsEl.querySelector('.js-contents');
        if (newContent && currentContent) currentContent.innerHTML = newContent.innerHTML;
        this.updateQuantityButtonStates();
        this.initFreeShippingBar();
      })
      .catch(() => window.location.reload());
  }

  // ─── ESTADO DE BOTONES "−" (mínimo = 1) ──────────────────────────────────

  updateQuantityButtonStates() {
    document.querySelectorAll('.quantity__input').forEach(input => {
      const qty = parseInt(input.value, 10) || 0;
      const container = input.closest('.quantity');
      if (!container) return;
      const minusBtn = container.querySelector('[name="minus"]');
      if (!minusBtn) return;
      const atMin = qty <= 1;
      minusBtn.disabled = atMin;
      minusBtn.style.opacity = atMin ? '0.4' : '';
      minusBtn.style.cursor = atMin ? 'not-allowed' : '';
    });
  }

  // ─── TOTALES ──────────────────────────────────────────────────────────────

  updateTotals(cartData) {
    const format = (cents) => {
      return new Intl.NumberFormat('es-UY', {
        style: 'currency',
        currency: 'UYU',
        minimumFractionDigits: 2
      }).format(cents / 100);
    };

    document.querySelectorAll('[data-cart-subtotal]').forEach(el => {
      el.textContent = format(cartData.items_subtotal_price);
    });

    document.querySelectorAll('[data-cart-total]').forEach(el => {
      el.textContent = format(cartData.total_price);
    });

    cartData.items.forEach(item => {
      const lineEl = document.querySelector(`[data-line-price="${item.key}"]`);
      if (lineEl) lineEl.textContent = format(item.final_line_price);
    });
  }

  // ─── BARRA DE ENVÍO GRATIS ────────────────────────────────────────────────

  initFreeShippingBar() {
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        this.updateFreeShippingBar(cart);
        this.updateTotals(cart);
      })
      .catch(err => console.error('Error iniciando barra de envío:', err));
  }

  listenToCartUpdates() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
        setTimeout(() => {
          fetch('/cart.js')
            .then(res => res.json())
            .then(cart => {
              this.updateFreeShippingBar(cart);
              this.updateTotals(cart);
              this.updateQuantityButtonStates();
            })
            .catch(() => {});
        }, 100);
      });
    }
  }

  updateFreeShippingBar(cartData) {
    const wrapper = document.querySelector('.free-shipping-bar-wrapper');
    if (!wrapper) return;

    if (!cartData.items?.length || cartData.item_count === 0) {
      wrapper.style.display = 'none';
      return;
    }
    wrapper.style.display = '';

    const threshold = 3000;
    const cartTotal = cartData.total_price / 100;
    const remaining = Math.max(0, threshold - cartTotal);
    const percentage = Math.min((cartTotal / threshold) * 100, 100);

    const messageContainer = wrapper.querySelector('.free-shipping-message');
    if (messageContainer) {
      if (cartTotal >= threshold) {
        messageContainer.className = 'free-shipping-message success';
        messageContainer.innerHTML = `
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM8 15L3 10L4.41 8.59L8 12.17L15.59 4.58L17 6L8 15Z" fill="#10B981"/>
          </svg>
          <span>¡Genial! Tenés envío gratis en zonas habilitadas de Montevideo y Canelones</span>
        `;
      } else {
        messageContainer.className = 'free-shipping-message pending';
        messageContainer.innerHTML = `
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path d="M17.5 6.66667L16.4167 5.58333L10 12L3.58333 5.58333L2.5 6.66667L10 14.1667L17.5 6.66667Z" fill="#6B7280" transform="rotate(90 10 10)"/>
          </svg>
          <span>Te faltan <strong>$${remaining.toFixed(2)}</strong> para obtener envío gratis</span>
        `;
      }
    }

    const progressFill = wrapper.querySelector('.progress-bar-fill');
    if (progressFill) {
      const currentWidth = parseFloat(progressFill.style.width) || 0;
      if (Math.abs(currentWidth - percentage) > 0.1) {
        progressFill.style.transition = 'none';
        progressFill.style.width = `${currentWidth}%`;
        progressFill.getBoundingClientRect();
        requestAnimationFrame(() => {
          progressFill.style.transition = 'width 0.5s cubic-bezier(0.4, 0, 0.2, 1)';
          requestAnimationFrame(() => { progressFill.style.width = `${percentage}%`; });
        });
      } else {
        progressFill.style.width = `${percentage}%`;
      }
      const pct = progressFill.querySelector('.progress-percentage');
      if (pct) pct.textContent = `${Math.round(percentage)}%`;
    }
  }
}

// ─── INICIALIZAR ──────────────────────────────────────────────────────────────

document.addEventListener('DOMContentLoaded', () => {
  window.cartManagerInstance = new CartManager();
});

window.addEventListener('pageshow', (event) => {
  if (event.persisted) {
    window.location.reload();
  }
});